<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <input type="checkbox" id="currentDayPassengersOnly" value="currentDayPassengersOnly" v-model="currentDayPassengersOnly">
        <label for="currentDayPassengersOnly"> Check this box to upload only passengers with the same appointment date as today</label>
        <br>

        <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />

        <v-col class="mb-4">
          <v-data-table
            hide-default-footer
            :headers="headers"
            :items="passengers"
            :items-per-page="5"
            class="elevation-1"
            disable-pagination
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">Add Passenger</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedPassenger.name" label="Name"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedPassenger.schedule" label="Status"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedPassenger.gate" label="Gate"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedPassenger.airline" label="Airline"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="editedPassenger.flight" label="Flight"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="postNowBoardingPassenger(item)" title="Click to set a passenger as the now boarding passenger">mdi-account</v-icon>
              <v-icon small class="mr-2" @click="editItem(item)" title="Click to edit a passenger">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)" title="Click to delete a passenger">mdi-delete</v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UploadExcelComponent from "../components/UploadExcel/index.vue";


export default {
  name: "AdminTable",

  components: { UploadExcelComponent },
  data: () => ({
    headers: [
      {
        text: "Passengers",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Status", value: "schedule" },
      { text: "Gate", value: "gate" },
      { text: "Airline", value: "airline" },
      { text: "Flight", value: "flight" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    dialog: false,
    passengers: [],
    waitMessage: 'Waiting..',
    currentDayPassengersOnly: false,
    editedIndex: -1,
    editedPassenger: {
      name: "",
      schedule: "",
      gate: "",
      airline: "",
      flight: "",
    },
    defaultItem: {
      name: "",
      schedule: "",
      gate: "",
      airline: "",
      flight: "",
    },
  }),

  mounted() {
    const storedPassengers = localStorage.getItem("passengers");
    if (storedPassengers) {
      this.passengers = JSON.parse(storedPassengers);
    }
  },

  methods: {
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      this.$message({
        message: "Please do not upload files larger than 1MB in size.",
        type: "warning",
      });
      return false;
    },

    handleSuccess({ results }) {
      const completePassengers = results.map(item => ({
        name: item.name,
        schedule: item.schedule || "Unknown",
        gate: item.gate || "N/A",
        airline: item.airline || "N/A",
        flight: item.flight || "N/A",
      }));

      // Store the data in localStorage
      localStorage.setItem("passengers", JSON.stringify(completePassengers));

      // Update the local passengers array
      this.passengers = completePassengers;
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.passengers[this.editedIndex], this.editedPassenger);
      } else {
        this.passengers.push(this.editedPassenger);
      }
      // Save the updated passengers to localStorage
      localStorage.setItem("passengers", JSON.stringify(this.passengers));
      this.close();
    },

    close() {
      this.dialog = false;
      this.editedIndex = -1;
      this.editedPassenger = Object.assign({}, this.defaultItem);
    },

    editItem(item) {
      this.editedIndex = this.passengers.indexOf(item);
      this.editedPassenger = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.passengers.indexOf(item);
      if (index !== -1) {
        this.passengers.splice(index, 1);
        // Save the updated list to localStorage
        localStorage.setItem("passengers", JSON.stringify(this.passengers));
      }
    },

    initialize() {
      // Reset the passengers array and remove from localStorage
      this.passengers = [];
      localStorage.removeItem("passengers");
    },
  },
};
</script>

<style>
  tr{
    color: white;
    font-weight: bold;
  }
  tr:nth-of-type(1n){
   background: #081e49;
  }
  tr:nth-of-type(2n){
   background: #0383D9;
  }
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper){
      background: black;
  }
  .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th{
    background: black;
    color: white !important;
    font-size: 1.1rem;
  }
  .mdi:before, .mdi-set{
    color: white;
  }
</style>
